import { Member } from '../models/member';
import { JsonPatchOperation } from '../models/json-patch-operation';

export type EditableContactField =
  | 'street'
  | 'number'
  | 'floor'
  | 'apartment'
  | 'city'
  | 'postcode'
  | 'state'
  | 'country'
  | 'homePhoneNumber'
  | 'mobilePhoneNumber'
  | 'email';

const EDITABLE_CONTACT_FIELDS: EditableContactField[] = [
  'street',
  'number',
  'floor',
  'apartment',
  'city',
  'postcode',
  'state',
  'country',
  'homePhoneNumber',
  'mobilePhoneNumber',
  'email',
];

const NULLABLE_CONTACT_FIELDS: EditableContactField[] = [
  'floor',
  'apartment',
  'homePhoneNumber',
  'mobilePhoneNumber',
  'email',
];

const toNullable = (value: string): string | null => (value === '' ? null : value);

const toPatchValue = (
  field: EditableContactField,
  member: Pick<Member, EditableContactField>
): string | number | null => {
  const value = member[field];
  if (typeof value === 'string' && NULLABLE_CONTACT_FIELDS.includes(field)) {
    return toNullable(value);
  }
  return value;
};

export const buildContactPatchOperations = (
  original: Pick<Member, EditableContactField>,
  updated: Pick<Member, EditableContactField>
): JsonPatchOperation[] =>
  EDITABLE_CONTACT_FIELDS.filter((field) => original[field] !== updated[field]).map(
    (field) => ({
      op: 'replace',
      path: `/${field}`,
      value: toPatchValue(field, updated),
    })
  );

export const buildLinkMemberPatchOperation = (userId: string): JsonPatchOperation[] => [
  {
    op: 'replace',
    path: '/UserId',
    value: userId,
  },
];
